import React from 'react'
import Path from '@leverege/path'
import { TextInput, NumericInput, Button, Text, Content, Pane, Dialog, Flex } from '@leverege/ui-elements'
import { Util } from '@leverege/api-attributes'
import ObjUtil from '@leverege/object-util'
import { Object } from 'core-js'
import classnames from 'classnames'

import S from './style.css'

export default class SimCollectionView extends React.Component {

  constructor( props, context ) {
    super( props, context )
    this.state = {}
  }

  onSetValue = ( { attribute, value, path, cxt } ) => {
    const { onSetValue } = this.props
    if ( onSetValue ) {
      onSetValue( { attribute, value, path, cxt } )
    }
  }

  onChangeAddKey = ( { value } ) => {
    this.setState( { toAddKey : value } )
  }

  removePrefix( prefix, path ) {
    if ( path.startsWith( `${prefix}/` ) ) {
      return path.replace( `${prefix}/`, '' )
    }
    if ( path === prefix ) {
      return ''
    }
    return path
  }
  
  onSetNewValue = ( { attribute, value, path, cxt } ) => {

    const { node } = this.props
    const { toAdd } = this.state
    const prefixPath = ( node.attribute && node.attribute.path ) || node.pathname
    const resPath = this.getResolvedPath( prefixPath, this.getChildPathContext() )

    const nToAdd = toAdd ? { ...toAdd } : {}

    if ( attribute ) {
      // value is path value array
      const noPrefix = this.removePrefix( resPath, attribute.path )
      nToAdd[noPrefix] = value
    } else {
      value.forEach( ( { path, value } ) => {
        const noPrefix = this.removePrefix( resPath, path )
        nToAdd[noPrefix] = value
      } )
    }
    this.setState( { toAdd : nToAdd } )
  }

  onAddNew = () => {
    const { toAdd, toAddKey } = this.state
    const { onSetValue, node } = this.props
    if ( toAddKey == null ) {
      return
    }

    const prefixPath = ( node.attribute && node.attribute.path ) || node.pathname
    const resPath = this.getResolvedPath( prefixPath, this.getChildPathContext() )

    if ( onSetValue ) {
      onSetValue( {
        value : Object.entries( toAdd || {} ).map( ( [ key, value ] ) => ( { path : `${resPath}${key ? `/${key}` : ''}`, value } ) )
      } )
    }
    this.setState( { toAdd : null, toAddKey : null, showAdd : false } )
  }

  onToggleAdd = () => {
    const { showAdd } = this.state
    const apply = { showAdd : !showAdd }
    if ( showAdd ) {
      apply.toAdd = null
      apply.toAddKey = null
    }
    this.setState( apply )
  }

  renderEditors() {
    const { renderEditors, node, cxt } = this.props
    return renderEditors( node, cxt, { onSetValue : this.onSetValue, showDelete : true, onDelete : this.deleteChild } ).map( ( editor ) => {
      // this is probably bad
      return editor.key.startsWith( 'view' ) ? <Pane key={editor.key} className={classnames( S.collectionItemEditor, S.rootEditor )}>{editor}</Pane> : editor
    } )
  }

  onClose() {}

  deleteChild = ( path, cxt ) => {
    const resPath = this.getResolvedPath( path, cxt )
    this.setState( { showDelete : { cxt, resPath, payload : { value : [ { path : resPath, value : null } ] } } } )
    // return this.onSetValue( { value : [ { path : resPath, value : null } ] } )
  }

  deleteSelf = () => {
    const { node, cxt } = this.props
    const path = ( node.attribute && node.attribute.path ) || node.pathname
    const resPath = this.getResolvedPath( path, cxt ).split( '/' ).slice( 0, -1 ).join( '/' )
    
    this.setState( { showDelete : { cxt, resPath, payload : { value : [ { path : resPath, value : null } ] } } } )
    // return this.onSetValue( { value : [ { path : resPath, value : null } ] } )
  }

  onDeleteConfirm = () => {
    const { showDelete } = this.state
    this.onSetValue( showDelete.payload )
    this.setState( { showDelete : null } )
  }

  onDeleteCancel = () => {
    this.setState( { showDelete : null } )
  }

  getChildPathContext() {
    const { toAddKey } = this.state
    const { cxt, node } = this.props
    const path = ( node.attribute && node.attribute.path ) || node.pathname
    const ids = Util.getPathIds( path )
    
    return { ...cxt, [ids[Object.keys( cxt || {} ).length]] : toAddKey }
  }

  getResolvedPath( path, cxt ) {
    const ids = Util.getPathIds( path )
    const colls = Util.getPathCollections( path )
    
    return Util.getResolvedPath( path, cxt, ids, colls )
  }

  render() {
    const { showAdd, toAdd, toAddKey, showDelete } = this.state
    const { node, getNewEditor } = this.props
    
    const path = ( node.attribute && node.attribute.path ) || node.pathname

    let newEditor
    if ( showAdd ) {
      const newContext = this.getChildPathContext()
      const resPath = this.getResolvedPath( path, newContext )
      let newDeviceData = {}
      Object.entries( toAdd || {} ).forEach( ( [ key, value ] ) => {
        newDeviceData[`${resPath}/${key}`] = value
      } )
      newDeviceData = ObjUtil.unflatten( newDeviceData, '/' )

      newEditor = getNewEditor(
        { ...node, name : toAddKey || 'new object' },
        newContext,
        {
          onSetValue : this.onSetNewValue,
          deviceData : newDeviceData,
          labels : false
        }
      )
    }

    const isArray = node.pathname.endsWith( '*' )
    const KeyEditorClazz = isArray ? NumericInput : TextInput
    const editorClazzProps = isArray ? { float : false } : {}

    return (
      <Pane className={classnames( S.collectionEditor, S.rootEditor )}>
        <Content.Header>
          <Flex className={S.row} variant="rowM">
            <Text className={S.collectionTitle}>Collection: {node.name.replace( /[@*]/g, '' )}</Text>
            <Flex className={classnames( S.right, S.force )}>
              <Button title="add item to collection" variant="addLink|link" icon="fa fa-plus" className={S.add} onClick={this.onToggleAdd} />
              <Button title="delete collection" variant="deleteLink|link" icon="fa fa-times" className={S.delete} onClick={this.deleteSelf} />
            </Flex>
          </Flex>
        </Content.Header>
        <Content.Area>
          <Flex className={S.editorList} variant="rowM">
            {this.renderEditors( this.onSetValue )}
          </Flex>
        </Content.Area>
        <Dialog className={S.dialog} show={showAdd} onClose={this.onClose}>
          <Flex variant="colM">
            <Text className={S.title}>{`Add Item to Collection: ${node.name}`}</Text>
            <Flex variant="colM">
              <Flex direction="column" align="flex-start">
                <Text>Key</Text>
                <KeyEditorClazz {...editorClazzProps} className={S.collectionKey} value={toAddKey} onChange={this.onChangeAddKey} />
              </Flex>
              <Flex direction="column" align="flex-start">
                <Text>Value</Text>
                {newEditor}
              </Flex>
            </Flex>
          </Flex>
          <Flex variant="rowM" justify="flex-end">
            <Button variant="cancel" onClick={this.onToggleAdd}>Cancel</Button>
            <Button variant="add" onClick={this.onAddNew}>Add</Button>
          </Flex>
        </Dialog>
        <Dialog.Question cancelVariant="cancel" okayVariant="add" message={`Are you sure you want to delete the data at ${showDelete && showDelete.resPath}?`} className={S.question} onCancel={this.onDeleteCancel} onOkay={this.onDeleteConfirm} show={!!showDelete} />
      </Pane>
    )
  }

}
